<template>
  <div class="student-center">
    <div class="wrapper">
      <div class="row1">
        <router-link to="mineCourse">
          <ReflectionBox :reflection="true" :transform="false">
            <div class="l-card animate__animated animate__fadeIn">我的课程</div>
          </ReflectionBox>
        </router-link>
      </div>
      <div class="row2">
        <a-row type="flex" justify="space-between">
          <a-col :span="5">
            <router-link to="mineWork">
              <ReflectionBox :reflection="true" :transform="true">
                <div
                  class="s-card animate__animated animate__flipInX"
                  style="background: #7276f5"
                  ref="card"
                >
                  我的作品
                </div>
              </ReflectionBox>
            </router-link>
          </a-col>
          <a-col :span="5">
            <router-link to="mineCenter">
              <ReflectionBox :reflection="true" :transform="true">
              <div
                class="s-card animate__animated animate__flipInX"
                style="background: #67c23a"
              >
                个人中心
              </div>
            </ReflectionBox>
            </router-link>
          </a-col>
          <a-col :span="5">
            <ReflectionBox :reflection="true" :transform="true">
              <div
                class="s-card animate__animated animate__flipInX"
                style="background: #e6a23c"
              >
                个人中心
              </div>
            </ReflectionBox>
          </a-col>
          <a-col :span="5">
            <ReflectionBox :reflection="true" :transform="true">
              <div
                class="s-card animate__animated animate__flipInX"
                style="background: #9f5bd6"
              >
                个人中心
              </div>
            </ReflectionBox>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import ReflectionBox from "@/components/common/ReflectionBox";
export default {
  name: "StudentCenter",
  components: {
    ReflectionBox,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="less">
.student-center {
  min-height: 100vh;
  background: url("/img/center/bg.jpg") no-repeat;
  background-size: 100%;
  .wrapper {
    width: 900px;
    margin: auto;
    padding-top: 50px;
  }
  .row1 {
    margin: 50px 0;
  }
  .l-card {
    width: 100%;
    // margin-bottom: 50px;
    line-height: 300px;
    // border-radius: 30px;
    box-shadow: #00000034 0 0 5px 5px;
    cursor: pointer;
    background: linear-gradient(
      180deg,
      rgb(59, 143, 238) 7%,
      rgb(31, 128, 170) 100%
    );
  }
  .s-card {
    height: 200px;
    // border-radius: 10px;
    // margin: 20px 20px;
    box-shadow: #00000034 0 0 5px 5px;
    cursor: pointer;
  }
}
</style>